import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('emailValidatorService', emailValidatorService);

    function emailValidatorService() {
        return {
            isValid: isValid,
            areValid: areValid
        };

        function isValid(emailAddress) {
            var regExp = /.+@.+\..+/;
            return !!emailAddress.match(regExp);
        }

        function areValid(emailAddresses) {
            var items = emailAddresses.split(';');
            for (var i = 0; i < items.length; i++) {
                var current = items[i].trim();

                if (current === '') {
                    continue;
                }

                if (!isValid(current)) {
                    return false;
                }
            }
            return true;
        }
    }
})();
